module.exports = __webpack_public_path__ + "static/img/construct2.af9cd23d.png";